import { render, staticRenderFns } from "./invoice.vue?vue&type=template&id=6909956a&scoped=true"
import script from "./invoice.vue?vue&type=script&lang=ts"
export * from "./invoice.vue?vue&type=script&lang=ts"
import style0 from "./invoice.vue?vue&type=style&index=0&id=6909956a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6909956a",
  null
  
)

export default component.exports